<template>
  <div class="privileged-bar" v-if="activeSites.length">
    <span class="privileged-bar__dot"></span>
    <span class="privileged-bar__label">
      Режим изменений:
      <span class="privileged-bar__sites">{{ activeSites.join(", ") }}</span>
    </span>
    <button class="privileged-bar__link" @click="$store.state.isOpenPrivilegedLogin = true">настроить</button>
    <button
      class="pv-btn pv-btn--ghost pv-btn--small"
      v-if="canBulkRefund"
      @click="$store.state.isOpenBulkRefund = true"
    >
      Рефанд списком
    </button>
    <button class="pv-btn pv-btn--danger pv-btn--small" @click="exit">Выйти</button>
  </div>
</template>

<script>
import "@/scss/_privileged.scss";
import "./privilegedLogin.scss";

import { SITES, SITE_NAMES, clearAll } from "@/utils/privileged";

export default {
  name: "PrivilegedBar",
  computed: {
    activeSites() {
      return SITES.filter((site) => this.$store.state.privilegedSites[site]).map((site) => SITE_NAMES[site]);
    },
    // Рефанд списком — для проекта, который сейчас открыт в панели
    canBulkRefund() {
      return Boolean(this.$store.state.privilegedSites[this.$store.state.toggleSite]);
    }
  },
  methods: {
    exit() {
      clearAll();
    }
  }
};
</script>
